import actions from '@/store/actions/userActions';
import * as types from '@/store/mutation-types';

/**
 * Define the module state
 *
 * @type {object}
 */
const moduleState = {
    isLoggedIn: false,
    token: null,
    full_name: 'Marija Marijanović',
    email: 'marija.marijanovic@example.com',
    phoneNumber: '+381 64 167 7367',
    pcmsId: '12345',
    pcId: 'asddg234g231edrbht2hgr13rg',
    loginError: '',
};

const mutations = {
    [types.STORE_USER](state, userData) {
        let email = userData.user.email;

        state.full_name = userData.user.first_name + ' ' + userData.user.last_name;
        state.email = email;
        state.token = userData.token.token;
        state.pcmsId = userData.user.id;
        state.pcId = email.substring(0, email.lastIndexOf("@"));
        state.isLoggedIn = true;
    },

    [types.CLEAR_AUTH_DATA](state) {
        state.token = null;
        state.isLoggedIn = false;
    },

    [types.SHOW_LOGIN_ERRORS](state, payload) {
        state.loginError = payload.message;
    },
};

/**
 * Define the module getters
 *
 * @type {object}
 */
const getters = {
    user: (state) => state,
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: moduleState,
};
